module.exports = __webpack_public_path__ + "static/media/topicWiseAnalysis.85a02daf.svg";